import React, { Component, Fragment } from 'react';
import { Row, Col, Container, Form, Button, Jumbotron } from 'react-bootstrap';
import config from '../config';
import Menu from './menu';
import CardPrincipalReport from './subcomponent/cardPrincipalReport';

class Home extends Component {
  constructor(props) {
    super(props);
    const currentCompany = sessionStorage.getItem('company');
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
    const yyyy = today.getFullYear();
    const todayFormat = yyyy + "-" + mm + "-" + dd;

    this.state = {
      data: [],
      empresa: currentCompany,
      fecha_inicial: todayFormat,
      fecha_final: todayFormat
    }

  }
  componentDidMount() {
    this.uploadReport();
  }

  uploadReport = (event) => {
    if (event) event.preventDefault();
    const busqueda = {
      fecha_ini: this.state.fecha_inicial,
      fecha_fin: this.state.fecha_final
    };
    const datasend = {
      method: 'POST',
      body: JSON.stringify(busqueda),
      headers: {
        'Content-Type': 'application/json',
        'empresa': this.state.empresa
      }
    };

    fetch(config.servBackEnd + '/notice', datasend)
      .then(res => res.json())
      .then((data) => {
        const info = data[0]
        this.setState({ data: info })
      })
      .catch((error) => console.error(error))
  }
  render() {
    const { data } = this.state;
    return (
      <Fragment>
        <Menu></Menu>
        <Jumbotron className="Jumbotron">
          <h2 className="m-3">REPORTE GENERAL DIARIO</h2>
        </Jumbotron>
        <Form onSubmit={this.uploadReport}>
          <Container fluid>
            <Row className="justify-content-md-center" >
              <Col className="mb-2" xs={5} lg={1}>FECHA INICIO</Col>
              <Col className="mb-2" xs={7} lg={2}>
                <Form.Control type="date" onChange={e => this.setState({ fecha_inicial: e.target.value })} value={this.state.fecha_inicial} required />
              </Col>
              <Col className="mb-2" xs={5} lg={1}>FECHA FIN</Col>
              <Col className="mb-2" xs={7} lg={2}>
                <Form.Control type="date" onChange={e => this.setState({ fecha_final: e.target.value })} value={this.state.fecha_final} required />
              </Col>
              <Col className="mb-2" xs={12} lg={2}>
                <Button id="actualizar" name="actualizar" type="submit" >Actualizar Reporte</Button>
              </Col>
            </Row>
          </Container>
        </Form>
        <Container>
          {
            data.map((info, i) => {
              return (
                <Container key={i}>
                  <Row className="justify-content-md-center">
                    <h4>Estado de los documentos - DIAN</h4>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col>
                      <CardPrincipalReport texto="Numero De Documentos sin enviar a la DIAN"
                        variant="primary"
                        titulo="PENDIENTES"
                        cantidad={info.SIN_CARGAR}></CardPrincipalReport>
                    </Col>
                    <Col>
                      <CardPrincipalReport texto="Documentos pendientes por confirmar por la DIAN"
                        variant="warning"
                        titulo="SIN CONFIRMAR"
                        cantidad={info.PENDIENTE_CONFIRMACION}></CardPrincipalReport>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col>
                      <CardPrincipalReport texto="Documentos cargados exitosamente en la DIAN"
                        variant="success"
                        titulo="EXITOSOS"
                        cantidad={info.CARGADA_EXITOSAMENTE}></CardPrincipalReport>
                    </Col>
                    <Col>
                      <CardPrincipalReport texto="Numero De Documentos rechazados por la DIAN"
                        variant="danger"
                        titulo="ERRORES"
                        cantidad={info.DOCUMENTO_ERROR}></CardPrincipalReport>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <h4>Estado de documentos enviados - CORREO</h4>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col>
                      <CardPrincipalReport texto="Documentos pendientes por enviar correo o enviados sin respuesta del cliente"
                        variant="primary"
                        titulo="PENDIENTES DESPACHO"
                        cantidad={info.PENDIENTES}></CardPrincipalReport>
                    </Col>
                    <Col>
                      <CardPrincipalReport texto="Documentos enviado via correo y aprobado por caducidad del tiempo para respuesta"
                        variant="warning"
                        titulo="APROBADO POR TIEMPO"
                        cantidad={info.APROBADO_TIEMPO}></CardPrincipalReport>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center">
                    <Col>
                      <CardPrincipalReport texto="Documentos enviado via correo y aprobado por el cliente dentro del tiempo permitido"
                        variant="success"
                        titulo="APROBADO POR CLIENTE"
                        cantidad={info.APROBADO_CLIENTE}></CardPrincipalReport>
                    </Col>
                    <Col>
                      <CardPrincipalReport texto="Documento enviado via correo y rechazado por el cliente"
                        variant="danger"
                        titulo="RECHAZADO POR CLIENTE"
                        cantidad={info.RECHAZADA}></CardPrincipalReport>
                    </Col>
                  </Row>
                </Container>
              );
            })
          }
        </Container>

        {/*
          data.map((element, i) => {
            return <Card key={'c' + i} className="text-left">
              <Card.Header key={'h' + i}>{element.TITULO_NOTICIA}( {element.TIPO_NOTICIA} )</Card.Header>
              <Card.Body key={'b' + i}>
                <Card.Title key={'t' + i}>Modulo: {element.MODULO}</Card.Title>
                <Card.Text key={'te' + i}>
                  {element.DESCRIPCION_NOTICIA}
                </Card.Text>
              </Card.Body>
              <Card.Footer key={'f' + i} className="text-muted">Disponibe a partir del: {funciones.formatDate(element.FECHA_LIBERACION_NOTICIA)}</Card.Footer>
            </Card>
          })
        */}

      </Fragment>
    );
  }
}
export default (Home);